var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-mgn-btm recipient-list" }, [
    _vm.subject
      ? _c("div", { staticClass: "recipient-list__subject" }, [
          _c("span", { staticClass: "small-mgn-right" }, [
            _vm._v(_vm._s(_vm.$t("subject")) + ":"),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.subject))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "recipient-list__to" }, [
      _c("span", { staticClass: "small-mgn-right" }, [
        _vm._v(_vm._s(_vm.$t("to")) + ":"),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.to))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recipient-list__cc" }, [
      _c("span", { staticClass: "small-mgn-right" }, [
        _vm._v(_vm._s(_vm.$t("cc")) + ":"),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.cc))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recipient-list__bcc" }, [
      _c("span", { staticClass: "small-mgn-right" }, [
        _vm._v(_vm._s(_vm.$t("bcc")) + ":"),
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.bcc))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }